import React from 'react';

const IconFlagRussian = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
    <g fill="none" fillRule="evenodd">
      <path d="M0 0H24V24H0z" transform="translate(-2 -2)" />
      <g fillRule="nonzero" transform="translate(-2 -2) translate(2 2)">
        <circle cx="10" cy="10" r="10" fill="#F0F0F0" />
        <path fill="#0052B4" d="M19.378 13.478C19.78 12.395 20 11.223 20 10c0-1.223-.22-2.395-.622-3.478H.622C.22 7.605 0 8.777 0 10c0 1.223.22 2.395.622 3.478l9.378.87 9.378-.87z" />
        <path fill="#D80027" d="M10 20c4.3 0 7.965-2.714 9.378-6.522H.622C2.035 17.286 5.7 20 10 20z" />
      </g>
    </g>
  </svg>
);

export default IconFlagRussian;
